/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Grid, Typography, IconButton, Paper, Divider } from '@material-ui/core/';

import Add from '@material-ui/icons/Add'
import Delete from '@material-ui/icons/Delete'

import Elements from '../Elements'

const styles = theme => ({

})

class FlexGroup extends Component {
    state = {  }

    renderGroup = () => {
        let groups = this.props.instance.elements.map((group, i) => {
            return (
                <Grid container item xs={12} spacing = {2} direction = 'row' wrap = 'wrap'>
                    {this.renderElement(group, i)}
                    <Grid item xs = {12}>
                        <Divider/>
                    </Grid>
                </Grid>
            )
        })

        return groups
    }

    renderElement = (group, group_index) => {
        let elements = group.map((el, i) => {
            //el.id = this.props.instance.id + "/" + group_index + "-" + i
            if (el.component !== "group") {
                return (
                    <div 
                        style = {{
                            width : el.component_params.findIndex(param => param.name === "width") !== -1 ? el.component_params.find(param => param.name === "width").value.number + "%" : '32%', 
                            padding : '5px'
                        }}>
                        <Paper style = {{
                            width : '100%',
                            padding : '10px'
                        }}
                        variant = 'outlined'
                        >
                            {Elements(el, {
                                update_value : (id, value_type, value) => this.props.update_value(id, value_type, value),
                                disabled : this.props.disabled
                            })}
                        </Paper>
                    </div>
                )
            } else {
                return (
                    <div style = {{width : '100%', padding : '5px'}}>
                        {Elements(el, {
                            update_value : (id, value_type, value) => this.props.update_value(id, value_type, value),
                            add_group : (id) => this.props.add_group(id),
                            delete_group : (id) => this.props.delete_group(id),
                            disabled : this.props.disabled
                        })}
                    </div>
                )
            }
        })

        return elements
    }

    render() {
        const { classes } = this.props
        return (
            <Paper variant = "outlined" style = {{width : '100%', padding : '10px'}}>
                <Grid container xs = {12} spacing = {1} direction = 'column'>
                    <Grid item xs = {12}>
                        <Typography variant = 'button'>{this.props.instance.name}</Typography>
                    </Grid>
                    {this.renderGroup()}
                    <Grid item xs = {6}>
                        <IconButton 
                            size = 'small'
                            variant = 'contained' 
                            color = 'primary' 
                            onClick = {() => this.props.add_group(this.props.instance.id)}
                        >
                            <Add fontSize = 'small'/>
                        </IconButton>
                        <IconButton 
                            size = 'small'
                            variant = 'contained' 
                            color = 'secondary' 
                            onClick = {() => this.props.delete_group(this.props.instance.id)}
                        >
                            <Delete fontSize = 'small'/>
                        </IconButton>
                    </Grid>
                </Grid>
            </Paper>
        );
    }
}

export default withStyles(styles)(FlexGroup);